import { ChangeDetectorRef, Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import {
   convertToForm,
   ReportParametersUnion,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-union.model';
import { ReportParameterFormFactoryService } from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form-factory.service';
import { ReportParameterFormService } from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form.service';
import { Store } from '@ngrx/store';
import { TileViewModes } from 'generated/graphql-types';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DashboardTile, VerboseTileIds } from 'src/app/pages/dashboard/models/dashboard-tile.model';
import { TileDataUnion } from '../../models/tile-data.model';
import { getTileViewMode } from '../../models/tile-view-mode.model';
import { TileState } from '../../state/tile.reducer';
import { getTile } from '../../state/tiles.selectors';

@Directive()
export class TileBase<P, T extends TileDataUnion> implements OnInit, OnDestroy {
   @Input('tileConfig') tileConfig: DashboardTile;

   @Input('isFullscreen') isFullscreen: boolean = false;

   @Input('isEditing') isEditing: boolean = false;

   @Input('showHeader') showHeader: boolean = true;

   @Input('isPreview') isPreview: boolean = false;

   @Output() configureParameters = new EventEmitter<void>();

   formService: ReportParameterFormService<P>;

   tile: TileState | undefined;

   tileData: T | undefined;

   dataChange = new Subject<void>();

   destroyed$ = new Subject<void>();

   tileViewModes = TileViewModes;

   get viewMode(): TileViewModes {
      return getTileViewMode(this.tileConfig, this.isFullscreen);
   }

   get isPreviewTile(): boolean {
      return this.tileConfig.dashboardTileId === VerboseTileIds.previewTile;
   }

   get isFullscreenTile(): boolean {
      return this.tileConfig.dashboardTileId === VerboseTileIds.fullscreenTile;
   }

   constructor(
      protected formServiceFactory: ReportParameterFormFactoryService,
      protected store: Store,
      public changeDetectorRef: ChangeDetectorRef,
      protected fb: UntypedFormBuilder,
      protected router: Router
   ) {}

   ngOnInit(): void {
      this.store
         .select(getTile(this.tileConfig.dashboardTileId))
         .pipe(takeUntil(this.destroyed$))
         .subscribe((t) => {
            this.tile = t;
            this.tileData = t?.data as TileDataUnion as T;
            this.dataChange.next();
            this.changeDetectorRef.detectChanges();
         });

      this.formService.form = convertToForm(this.tileConfig.dashboardTileParameters, this.fb);
   }

   onConfigureParameters(): void {
      this.formService.orderValues();
      const orderedDashboardTileParameters: ReportParametersUnion[] = this.tileConfig.dashboardTileParameters.map(
         (dtp) => {
            const foundFormValue = this.formService.form.value.values.find(
               (fv) => fv.parameterType === dtp.parameterType
            );
            const foundSortOrder = foundFormValue?.sortOrder ?? dtp.sortOrder;
            return {
               ...dtp,
               sortOrder: foundSortOrder,
            };
         }
      );
      this.formService.form = convertToForm(orderedDashboardTileParameters, this.fb);
      //this.formService.resetConfig();
      this.configureParameters.emit();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   routeFromTile(route: string, e: MouseEvent | null = null) {
      this.router.navigateByUrl(route);
   }
}
